import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import CardInput from "Components/CardInput";
import moment from "moment";
import React, { useState } from "react";
import { Button, Row, Col, Form, Modal, Spinner, Alert } from "react-bootstrap";
// import DatePicker from "react-datepicker";
import { formatDate, STRIPR_WARNING_MSG } from "../../../utils";
import { diplayCreditCard } from "../Cards/Utils";
import { EDIT_SUBSCRIPTION_TYPES, paymentFieldsReqCallback, paymentTypeReqCallback, required, requiredIf } from "./AddSubscription";
import * as CustomerApi from '../../../Services/CustomerApi';
import { useEffect } from "react";
import { useCallback } from "react";


const changeSubscriptionValidators = [
    {
        key: "subscriptionTypeId",
        validators: [required]
    },
    {
        key: "addSubscriptionType",
        validators: [requiredIf(paymentTypeReqCallback)],
    },
    {
        key: "cardId",
        validators: [requiredIf(paymentFieldsReqCallback("cardId"))]
    },
];

const calculateUpgradeAmountToPay = (userSubscription, subscriptionType, lastestPayment, newSubscriptionType)=>{
    console.log(userSubscription);
    console.log(subscriptionType);
    console.log(newSubscriptionType);
    console.log(lastestPayment);

    let pendingAmount = 0;
    let inTrialPeriod = false;
    if(subscriptionType.trialPeriodDays && subscriptionType.trialPeriodDays > 0){
        const trialEndDate = moment(userSubscription.startDate)
        .add((subscriptionType.trialPeriodDays-1),'days')
        .set({ hours: 23, minutes: 59, seconds: 59, milliseconds: 999 });
        inTrialPeriod = trialEndDate.isAfter();

    }

    if(!inTrialPeriod){
        const daysRemaining = moment(userSubscription.validityEndDate).diff(moment(), 'days');
        pendingAmount = (lastestPayment?.transactionValue || 0) / subscriptionType.validityDays * daysRemaining;
        pendingAmount = parseFloat(pendingAmount.toFixed(2));

    }

    const newSubAmount = ((100-(newSubscriptionType.discountPercentage || 0))*newSubscriptionType.value)/100;
    let amountToPay = newSubAmount - pendingAmount;
    if(amountToPay < 0){
        amountToPay = 0;
    }
    return amountToPay;
}


const ChangeSubscription = ({ show, handleClose, subscription, 
    subscriptionTypes, subscriptionTiers,  handleSuccess, cards, stripeKey }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [formData, setFormData] = useState({ values: { startDate: new Date() }, errors: {} });
    const [submitting, setSubmitting] = useState(false);
    const [stripeError, setStripeError] = useState(undefined);
    const [apiError, setApiError] = useState(undefined);
    const [latestPayment, setLatestPayment] = useState(null);

    const fetchLatestPayment = useCallback(async () => {
        const data = await CustomerApi.getSubscriptionLatestPayment(subscription.id);
        setLatestPayment(data);
    }, [subscription.id]);

    useEffect(()=>{
        fetchLatestPayment();
    },[fetchLatestPayment])

    const subscriptionType = subscriptionTypes?.find(st => st.id === subscription?.subscriptionType?.id);
    const subsTimeZone = subscription?.subscriptionType?.timezone;

    const validateForm = (data)=>{
        const errors = {};
        changeSubscriptionValidators.forEach(({ key, validators }) => {
            const value = data[key];
            let error;
            validators.forEach(validator => {
                if (!error) {
                    console.log(key,data)
                    error = validator(value,data);
                }
            });
            if (error) {
                errors[key] = error;
            }
        });
        return errors;
    }

    const handleChange = (field, value) => {
        if(field === "subscriptionTierId"){
            handleChange("subscriptionTypeId", '');
        }
        if(field === "subscriptionTypeId"){
            handleChange("addSubscriptionType", '');
        }

         setFormData((prevFormData) => {
            const { values: prevValues, errors: prevErrors } = prevFormData;
            const validators = changeSubscriptionValidators.find(({key})=>(key === field))?.validators || [];
            let error;
            validators.forEach(validator => {
                if (!error) {
                    error = validator(value);
                }
            });
            return {
                ...prevFormData,
                values: { ...prevValues, [field]: value },
                errors: { ...prevErrors, [field]: error}
            }
        });
    }

    const onSubmit = async () => {
        const { values: data } = formData;

        const errors = validateForm(data);
        if (Object.keys(errors).length > 0) {
            setFormData((prevFormData) => {
                const { errors: prevErrors } = prevFormData;
                return {
                    ...prevFormData,
                    errors: { ...prevErrors, ...errors }
                }
            })
            return;
        }

        const {addSubscriptionType} = data;
        let newCardToken;
        setSubmitting(true);
        setApiError(undefined);
        setStripeError(undefined);
        if(addSubscriptionType === "NEW_CARD"){
            if (!stripe || !elements) {
                // Stripe.js has not yet loaded.
                // Make sure to disable form submission until Stripe.js has loaded.
                setStripeError("Stripe hasn't loaded yet.");
                setSubmitting(false);
                return;
            }
            const { token:data, error }  = await stripe.createToken(elements.getElement(CardElement));
            if (error) {
                setStripeError(error.message);
                setSubmitting(false);
                return;
            }
            newCardToken = data.id;
        }

        const sanitizedData = {
            oldUserSubscriptionId: subscription.id,
            newSubscriptionTypeId: data?.subscriptionTypeId,
            paymentType: data?.addSubscriptionType || undefined,
            newCardId: data?.cardId,
            newCardToken,
        };

        try {
            await handleSuccess(sanitizedData);
            setSubmitting(false);
        } catch (e) {
            setApiError(e?.message || "System error");
            setSubmitting(false);
            console.log(e)
        }

    }

    const selectedSubsTierId = formData?.values?.subscriptionTierId;
    const availableSubsTiers = (subscriptionTiers || []);
    const availableSubsTypes = (subscriptionTypes || []).filter((st)=>(
        (!selectedSubsTierId || st?.subscriptionTier?.id === selectedSubsTierId) 
        && (subscriptionType?.id !== st?.id)
        ));
    const selectedSubsType = subscriptionTypes?.find(st => st.id === formData?.values?.subscriptionTypeId);
    const addSubscriptionType = formData?.values?.addSubscriptionType;
    const noExistingCards = !(cards?.length !== 0);
    const oldPriority = (subscriptionType?.subscriptionTier?.priority || 0);
    const newPriority = selectedSubsType?.subscriptionTier?.priority || 0;
    const isUpgrade = oldPriority <= newPriority;
    console.log(oldPriority, newPriority, isUpgrade)
    let transactionValue;
    if(selectedSubsType){
        transactionValue = ((selectedSubsType?.value *(100-selectedSubsType?.discountPercentage))/100);
    }
    if(isUpgrade && selectedSubsType){
        transactionValue = calculateUpgradeAmountToPay(subscription, subscriptionType, latestPayment, selectedSubsType)
    }
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Change Subscription {subscription.subscriptionType.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {selectedSubsType &&<Alert variant="warning">
                    {`Are you sure you want to ${isUpgrade ? 'upgrade' : 'downgrade'} the subscription?`}
                    </Alert>}
                    {<Col className="mb-5">
                        Please select the new Subscription Tier and Type below*
                    </Col>}
                    <Form.Group as={Row} className="mb-3" controlId="frmSubscriptionTier">
                        <Form.Label column sm={3}>Subscription Tier*</Form.Label>
                        <Col sm={9}>
                            <Form.Select
                                value={selectedSubsTierId}
                                onChange={(e) => handleChange('subscriptionTierId', e.target.value)}
                                isInvalid={formData?.errors?.subscriptionTierId}
                            >
                                <option value="">--</option>
                                {availableSubsTiers.map(st => (<option key={st.id} value={st.id}>{st.name}</option>))}
                            </Form.Select>
                            {formData?.errors?.subscriptionTierId && (<span className="error-text">
                                {formData?.errors?.subscriptionTierId}
                            </span>)}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3" controlId="frmSubscriptionType">
                        <Form.Label column sm={3}>Subscription Type*</Form.Label>
                        <Col sm={9}>
                            <Form.Select
                                value={formData?.values?.subscriptionTypeId}
                                onChange={(e) => handleChange('subscriptionTypeId', e.target.value)}
                                isInvalid={formData?.errors?.subscriptionTypeId}
                            >
                                <option value="">--</option>
                                {availableSubsTypes.map(st => (<option key={st.id} value={st.id}>{st.name}</option>))}
                            </Form.Select>
                            {formData?.errors?.subscriptionTypeId && (<span className="error-text">
                                {formData?.errors?.subscriptionTypeId}
                            </span>)}
                        </Col>
                    </Form.Group>
                    {transactionValue>0&&<Form.Group as={Row} className="mb-3" controlId="frmAddSubscriptionType">
                        <Form.Label column sm={3}>Payment Method*</Form.Label>
                        <Col sm={9}>
                            <Form.Select
                                value={addSubscriptionType}
                                onChange={(e) => handleChange('addSubscriptionType', e.target.value)}
                                isInvalid={formData?.errors?.addSubscriptionType}
                            >
                                <option value="">--</option>
                                {EDIT_SUBSCRIPTION_TYPES.map(st => {
                                    const isExistingOpt = st.value === "EXISTING_CARD";
                                    const isDisabled = isExistingOpt && noExistingCards;
                                    return (<option
                                        key={st.value}
                                        value={st.value}
                                        disabled={isDisabled}
                                    >
                                        {`${st.label}${isDisabled ? ' (No cards found)': ''}`}
                                    </option>)
                                })}
                            </Form.Select>
                            {formData?.errors?.addSubscriptionType && (<span className="error-text">
                                {formData?.errors?.addSubscriptionType}
                            </span>)}
                        </Col>
                    </Form.Group>}
                    {(addSubscriptionType === "EXISTING_CARD")&& (
                         <Form.Group as={Row} className="mb-3" controlId="frmCardId">
                         <Form.Label column sm={3}>Credit Card*</Form.Label>
                         <Col sm={9}>
                             <Form.Select
                                 value={formData?.values?.cardId}
                                 onChange={(e) => handleChange('cardId', e.target.value)}
                                 isInvalid={formData?.errors?.cardId}
                             >
                                 <option value="">--</option>
                                 {cards.map(card => (<option key={card.id} value={card.id}>{diplayCreditCard(card)}</option>))}
                             </Form.Select>
                             {formData?.errors?.cardId && (<span className="error-text">
                                 {formData?.errors?.cardId}
                             </span>)}
                         </Col>
                     </Form.Group>
                    )}
                     {(addSubscriptionType === "NEW_CARD")&& (
                         <Form.Group as={Row} className="mb-3" controlId="frmNewCardToken">
                            {(!stripeKey) && (
                                <Alert variant="warning">{STRIPR_WARNING_MSG}</Alert>
                            )}
                         <Form.Label column sm={3}>New Credit Card*</Form.Label>
                         <Col sm={9}>
                            <div className="border-box">
                                <CardInput/>
                            </div>
                            {stripeError && (<span className="error-text">
                                {stripeError}
                            </span>)}
                         </Col>
                     </Form.Group>
                    )}
                    {(selectedSubsType) && <Form.Group as={Row} className="mb-3">
                        <h4>Total : {transactionValue} {selectedSubsType?.currencyCode}</h4>
                    </Form.Group>}
                </Form>
                {selectedSubsType && !isUpgrade &&<div style={{fontSize : 14}}>
                *When downgrading, the customer’s subscription will be downgraded 
                once their current subscription expires. The current subscription 
                will continue to be active until {formatDate(subscription?.validityEndDate, subsTimeZone, "DD MMM YYYY z")}.
                </div>}
                {apiError && (
                    <Alert variant="danger">{apiError}</Alert>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={onSubmit} disabled={submitting}>
                    {submitting && <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />}
                    Change Subscription
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ChangeSubscription;